import { RadioGroupField, RadioGroupFieldProps } from 'components/form'
import { RastreioCancerPerguntaOpcaoEnum } from 'graphql/types.generated'

const options = [
  { value: RastreioCancerPerguntaOpcaoEnum.SIM, label: 'Sim' },
  { value: RastreioCancerPerguntaOpcaoEnum.NAO_NAO_SABE_NAO_LEMBRA, label: 'Não/Não sabe/Não lembra' },
]

export function SangramentoRelacaoSexualRadioField(
  props: Readonly<Omit<RadioGroupFieldProps<RastreioCancerPerguntaOpcaoEnum>, 'options'>>
) {
  return <RadioGroupField {...props} label='Tem ou teve algum sangramento após relação sexual?' options={options} />
}
